<template>
  <div class="form-outline">
    <form-legend :field="field" />
    <v-menu
      class="TimeEditor"
      ref="menu"
      v-model="timeMenu"
      color="primary-action"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      z-index="999"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="fieldValue"
          :style="getSize(field.field_options.size)"
          prepend-icon="mdi-clock-outline"
          readonly
          v-bind="{ ...attrs, ...darkOrLightMode }"
          v-on="on"
          :hint="field.field_options.description"
          persistent-hint
          :rules="getFieldRules({ required: field.required })"
        >
          <template v-slot:prepend>
            <v-btn icon v-on="on">
              <v-icon>mdi-clock-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:message="{ message }">
            <legend v-html="translateIfExist(message)"></legend>
          </template>
        </v-text-field>
      </template>
      <v-time-picker
        :lang="selectedLang"
        color="primary-action"
        class="n-form-field"
        format="24hr"
        v-model="fieldValue"
        @input="dateMenu = false"
        :readonly="readonly"
      />
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dateTimeMixin from '../../../mixins/dateTimeMixin';
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [dateTimeMixin, formsMixin],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      timeMenu: false,
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
    };
  },
  computed: {
    ...mapState('language', ['selectedLang']),
  },
  watch: {
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
    fieldValue(newValue) {
      this.$emit('formUpdated', this.field.cid, newValue);
    },
  },
};
</script>
